import React, { useEffect, useState, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Tabs from "@mui/material/Tabs";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";

import MyContext from "../../../context/MyContext";
import AuthContext from "../../../context/userAuth.context";
const BackgroundMusicModal = (props) => {
  const {
    enableAutoGuides,
    setenableAutoGuides,
    setenableGrid,
    enableGrid,
    setenableRuler,
    enableRuler,
  } = useContext(MyContext);

  const { authenticationData } = useContext(AuthContext);
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const [value, setValue] = React.useState(0);
  const [adminMusics, setadminMusics] = useState([]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  useEffect(() => {
    setadminMusics(props.bgMusicList.adminData);
  }, [props.bgMusicList]);

  const playSpecificAudio = (audioSrc, event) => {
    var AllAudio = document.getElementsByTagName("audio");
    for (let index = 0; index < AllAudio.length; index++) {
      AllAudio[index].pause();
    }
    var element = document.getElementById(audioSrc);
    element.src = authenticationData.ApiBaseURL + "/" + audioSrc;
    element.style.display = "inline-block";
    element.play();
    event.target.style.display = "none";
  };
  const convert1000 = (time) => {
    var arr = time.split(":");
    var minutesToSecond = arr[0] * 60;
    return parseInt(arr[1]) + parseInt(minutesToSecond);
  };
  const AddbgAudio = (e, item) => {
    // e.target.style.display = "none";
    // var addedBtn = document.getElementsByTagName("Addedbtn");
    // for (let index = 0; index < AllAudio.length; index++) {
    //   addedBtn[index].style.display = "none";
    // }
    var time = item.duration.split(" minutes")[0];
    time = convert1000(time);

    props.setbgmusicState({
      added: true,
      src: item.path,
      volume: 100,
      name: item.name,
      duration: time,
    });

    //props.setbgmusicModal(false);
  };
  return (
    <>
      <Dialog
        className="bgMusicWrapper"
        open={props.bgmusicModal}
        maxWidth="lg"
        fullWidth={true}
        onClose={() => props.setbgmusicModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title mr-4"
          style={{ marginRight: "50px" }}
        >
          Select background music to play on all slides.
          {props.bgmusicState.src !== "" && (
            <Button
              onClick={() => {
                props.setbgmusicState({
                  added: false,
                  src: "",
                  volume: 100,
                  name: "",
                  duration: "",
                });
              }}
              className="Addedbtn"
              color="error"
              style={{
                textTransform: "none",

                float: "right",
              }}
              variant="contained"
              disableElevation
            >
              Remove Background Music
            </Button>
          )}
          <Box>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                style={{ textTransform: "none" }}
                label="Free Music"
                {...a11yProps(0)}
              />
              <Tab
                style={{ textTransform: "none" }}
                label="Uploaded"
                {...a11yProps(1)}
              />
            </Tabs>
          </Box>
          <IconButton
            onClick={() => props.setbgmusicModal(false)}
            style={{ position: "absolute", right: "10px", top: "10px" }}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <TabPanel value={value} index={0}>
            {adminMusics && adminMusics.length > 0 && (
              <div style={{ height: "calc(100% - 20px)", overflow: "scroll" }}>
                {adminMusics.map((item) => {
                  return (
                    <div className="soundItem">
                      <div className="soundName">
                        <label>
                          <strong>{item.name.split(".")[0]}</strong>
                        </label>
                        <label className="soundduration">{item.duration}</label>
                      </div>
                      <div className="audioPlayerSound">
                        <audio
                          controls
                          id={item.path}
                          style={{ display: "none" }}
                        >
                          <source src="" type="audio/mp3" />
                        </audio>
                      </div>
                      <div className="actionbtn">
                        <Stack direction="row" spacing={1}>
                          <Button
                            style={{ textTransform: "none" }}
                            variant="outlined"
                            onClick={(e) => playSpecificAudio(item.path, e)}
                          >
                            Play audio
                          </Button>

                          {props.bgmusicState.src === item.path ? (
                            <Button
                              className="Addedbtn"
                              color="success"
                              style={{ textTransform: "none" }}
                              variant="outlined"
                              disableElevation
                            >
                              Added
                            </Button>
                          ) : (
                            <Button
                              className="Addbtn"
                              style={{ textTransform: "none" }}
                              variant="contained"
                              disableElevation
                              onClick={(e) => {
                                AddbgAudio(e, item);
                              }}
                            >
                              Add to video
                            </Button>
                          )}
                        </Stack>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </TabPanel>
          <TabPanel value={value} index={1}>
            Item Two
          </TabPanel>
        </DialogContent>
        {/* <DialogActions>
          <Button>Disagree</Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
};

export default BackgroundMusicModal;
